import { useEffect, useState } from 'react';
import './DialogEditor.scss';
import Message, { MessageType } from '../../../../structures/message';
import Member from '../../../../structures/member';
import { Button, ButtonGroup, Container, Dropdown, Form, FormField, Grid, Icon, Input, Label, Loader, Popup, TextArea } from 'semantic-ui-react';
import EditMessageDialog from './components/EditMessageDialog/EditMessageDialog';
import api, { baseURL } from '../../../../utils/api';
import Project from '../../../../structures/project';
import ProjectPart from '../../../../structures/projectPart';
import Fragment from '../../../../structures/fragment';

interface DialogEditorProps {
    project:Project;
    part: ProjectPart;
    fragment: Fragment;
}

function DialogEditor({project, part, fragment}:DialogEditorProps) {
    const [messages, setMessages] = useState<Message[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [isOpenWriteNewMessageManualy, setIsOpenWriteNewMessageManualy] = useState(false)
    const [currentMemberForManualyWrite, setCurrentMemberForManualyWrite] = useState<Member|null>(null)
    const [currentMessageForManualyWrite, setCurrentMessageForManualyWrite] = useState('')
    const [editMessage, setEditMessage] = useState<Message|null>(null)

    const members = project.members.filter(m=>fragment.members.includes(m.id));
    const place = project.places.find(m=>fragment.places[0].includes(m.id))!;
    const loadMessages = async () => {
        setMessages(await api.getMessagesForDialog(project.id, part.id, fragment.id));
    };
    useEffect(()=>{loadMessages();}, []);

    const generateNextMessage = async () => {
      setIsLoading(true);
      let memberIdWhoContinueDialog = await api.determineWhoContinueDialog(project.id, part.id, fragment.id);
      let memberWhoStartDialog = project.members.filter(x=>x.id === memberIdWhoContinueDialog)[0]
      let message = await api.getNextMessage(project.id, part.id, fragment.id, memberWhoStartDialog.id);
      await api.addMessageInDialog(project.id, part.id, fragment.id, memberWhoStartDialog.id, message, MessageType.Ai)
      await loadMessages();
      setIsLoading(false);
    };

    const writeNewMessageManually = ()=>{
      setMessages(messages => [...messages, new Message(currentMemberForManualyWrite?.id!, currentMessageForManualyWrite, MessageType.Human)]);
      setIsOpenWriteNewMessageManualy(false);
      setCurrentMemberForManualyWrite(null);
      setCurrentMessageForManualyWrite('');
    }

    return <Container className='current-dialog'>        
    <div className='current-dialog-description-container'>
        <div className='image-container'>
            <img alt={place.name} src={`${baseURL}/api/generatedImage/${place.imageId}`}/>
        </div>
        <div>
            <div className='info'>
                <div className='title'>{place.name}</div>
                <div className='description'>{place.description}</div>
            </div>
            {members.length > 0 && <div className='members'>
                {members.map((member, index) => <Popup basic inverted key={index} content={member.context} trigger={<Label key={index} color={member.color}>{member.name} ({member.role})</Label>} />)}
            </div>}
            <div>{fragment.description}</div>  
        </div>
    </div>
    <div className='messages'>
        {messages.map((message, index) => {
            const member = project.members.find(m => m.id == message.memberId)!;
            return <div key={index} className={'message ' + member.color}>
            <div className='image'><img alt={member.name} src={`${baseURL}/api/generatedImage/${member.imageId}`}/></div>
            <div>
                <div className='author'>{message.type == MessageType.Ai ? '' : <Icon name='user outline' />} {member.name} ({member.role})</div> 
                <p className='content'>{message.content}</p>
            </div> 
            <div className='actions'>
                <Popup basic on='click' closeOnPortalMouseLeave trigger={<Icon size='small' name='ellipsis vertical' />} content={
                <div className='message-actions-container'>
                <Button basic fluid size='tiny' onClick={() => {
                    setMessages(messages =>{
                    return messages.filter((_, i) => i !== index);
                    })
                }}><Icon name='trash'/> Удалить</Button>
                <Button basic fluid size='tiny' onClick={() => {setEditMessage(message);}}><Icon name='edit outline' /> Редактировать</Button>
                <Button basic fluid size='tiny'><Icon name='magic' /> Придумать другое</Button>
                <Button basic fluid size='tiny'><Icon name='refresh' /> Переформулировать</Button>
                </div>
                } />
            </div>
            </div>;
        })}
        {isLoading && <Loader active inline size='tiny' />}
        {!isLoading && <>
        {isOpenWriteNewMessageManualy ? <div>
            <Dropdown
            placeholder='Выберите участника'
            selection
            options={members.map(member => ({key: member.role, value: member.role, text: `${member.name} (${member.role})`}))}
            onChange={(e, data) => {
                setCurrentMemberForManualyWrite(members.filter(x=>x.role === data.value)[0]);
            }}
            value={currentMemberForManualyWrite?.role}
            inline
            />
            <Input inline value={currentMessageForManualyWrite} onChange={(e) => setCurrentMessageForManualyWrite(e.target.value)}/>
            <Button disabled={currentMemberForManualyWrite === null || currentMessageForManualyWrite === ''} primary onClick={writeNewMessageManually}>Добавить</Button>
            <Button basic onClick={()=>{setIsOpenWriteNewMessageManualy(false)}}>Отмена</Button>
        </div> : <div className='buttons-container-for-next-message'>
            <ButtonGroup style={{width: "50%"}} size='tiny'>
                <Button icon fluid onClick={generateNextMessage} primary><Icon name='magic'/> Придумать {messages.length > 0 ? 'Cледующее' : 'Первое'} сообщение</Button>
                <Button icon fluid onClick={()=>{setIsOpenWriteNewMessageManualy(true)}}><Icon name='edit outline'/> Написать {messages.length > 0 ? 'Cледующее' : 'Первое'} сообщение</Button>
            </ButtonGroup>                

        </div>}
        </>}
    </div>
    {editMessage != null && <EditMessageDialog project={project} message={editMessage} onSave={(newMessage)=>{
    // setMessages(messages => messages.map(x => x.member === newMessage.member && x.content === editMessage.content ? newMessage : x))
    setEditMessage(null)
    }} />}
    </Container>;
};

export default DialogEditor;